import { Flex } from 'theme-ui'
import React, { ReactElement } from 'react'
import { Checkbox } from 'ui/Checkbox'

export default function AcknowledgeDeletionCheckbox({
  isChecked,
  checkboxText,
  onChange,
}: {
  isChecked: boolean
  checkboxText: string
  onChange: (checked: boolean) => void
}): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        position: ['absolute', 'static'],
        left: 0,
        bottom: 0,
        px: '1.2rem',
        py: '0.8rem',
        backgroundColor: 'white8',
        gap: '0.8rem',
        flexDirection: 'column',
      }}
    >
      <Checkbox
        text={checkboxText}
        isChecked={isChecked}
        containerSx={{
          width: '100%',
          textAlign: 'left',
          justifyContent: 'flex-start',
          fontSize: '1.2rem',
          fontWeight: 400,
          lineHeight: '140%',
        }}
        sx={{
          width: '2.8rem',
          pt: '0.4rem',
          mb: 'auto',
          flexShrink: 0,
        }}
        onChange={() => {
          onChange(!isChecked)
        }}
      />
    </Flex>
  )
}
